import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c69eba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "apply-wrapper" }
const _hoisted_2 = { class: "apply-help" }
const _hoisted_3 = { style: {"margin":"24px auto 20px"} }
const _hoisted_4 = {
  key: 0,
  class: "form-wrapper"
}
const _hoisted_5 = { style: {"padding":"24px","padding-bottom":"60px"} }
const _hoisted_6 = { class: "content-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("小规模纳税人")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("一般纳税人")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " 一般纳税人会设计票额进行项税计算,小规模纳税人则无进行项税计算 ", -1))
const _hoisted_10 = { class: "apply-detail" }
const _hoisted_11 = { class: "item text-overflow" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "营业执照名称：", -1))
const _hoisted_13 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "系统公司简称：", -1))
const _hoisted_15 = { class: "item text-overflow" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "纳税识别号：", -1))
const _hoisted_17 = {
  class: "apply-detail",
  style: {"margin-bottom":"0"}
}
const _hoisted_18 = { class: "item text-overflow" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "法人：", -1))
const _hoisted_20 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "纳税类型：", -1))
const _hoisted_22 = { class: "item text-overflow" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "股东全称：", -1))
const _hoisted_24 = {
  key: 2,
  class: "flow-box"
}

import {
  onMounted,
  ref,
  reactive,
  computed,
  withDefaults,
  createVNode,
} from "vue";
import type { FormInstance } from "ant-design-vue";
import { USERLIST } from "../../const/home";
import HeadTitle from "@/components/HeadTitle.vue";
import HelpFile from "@/components/HelpFile.vue";
import HelpText from "@/components/HelpText.vue";
import ButtonGroup from "@/components/ButtonGroup.vue";
import Approval from "@/components/Approval.vue";
import Image from "@/components/Image.vue";

import {
  GetFilterRegions,
  MatchPrefixCode,
  GetCity,
  GetFilterStaff,
} from "@/api/api";
import { useRouter, useRoute } from "vue-router";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

import { watch, watchEffect } from "vue";
import { useStore } from "vuex";
import { GetCurrentMyPageList } from "@/api/index";

import { FileType, NodeItem } from "../../types/procss";
import {
  startAccountSetApplication,
  accountSetApplicationDetail,
} from "../../api/process_accountApply";
import { message, Modal } from "ant-design-vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    flowData: { default: () => [] }
  },
  emits: ["update-flow"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { flowData: NodeItem[] }

const route = useRoute();
const { query } = route;
const id = ref(query.id || "");
const refresh = ref<boolean>(false);
const firstIn = ref<boolean>(true);
const applyFormRef = ref<FormInstance>();

const currentData = ref<NodeItem>();
const preData = ref<NodeItem>();
const BranchCompanyFlowId = ref<number>(0);
const WorkFlowId = ref<number>(0);
const store = useStore();

const personInfo = computed(() => store.getters.getSimpleInfo);
let actionButtons = ref<string[]>([]);



onMounted(() => {
  //
});

watch(
  () => props.flowData,
  (val) => {
    if (!val) return;
    const { id, type } = route.query;
    if (id && type) {
      //从列表也进入
      currentData.value = val.find((item: NodeItem) => item.Code == type);
      BranchCompanyFlowId.value = currentData.value.BranchCompanyFlowId;
      preData.value = props.flowData.find((_item: NodeItem) =>
        currentData.value?.PreConditionCode.includes(_item.Code)
      );
    } else {
      //从流程节点页面进入
      currentData.value = val.find((item: NodeItem) => item.Code == "13");
      BranchCompanyFlowId.value = currentData.value.BranchCompanyFlowId;
      preData.value = props.flowData.find((_item: NodeItem) =>
        currentData.value?.PreConditionCode.includes(_item.Code)
      );

      // if (currentData.value) {
      //   if (firstIn.value) {
      //   }
      // }
    }
    // firstIn.value = false;
    if (currentData.value?.IsOperation) {
      //前置节点已完成
      preData.value = null;
    }
    getAccountSetApplicationDetail();
  },
  {
    deep: true,
  }
);

const getAccountSetApplicationDetail = async () => {
  let params = { Id: BranchCompanyFlowId.value };
  if (!BranchCompanyFlowId.value && route.query.staffId) {
    params.StaffId = Number(route.query.staffId);
  }
  const { Data } = await accountSetApplicationDetail(params);
  WorkFlowId.value = Data?.WorkFlowId;
  form.value = Data?.PageData;
  if (form.value.TaxType == 0) {
    form.value.TaxType = undefined;
  }
  form.value.PageFiles = Data?.PageFiles;
  actionButtons.value = Data?.ActionButtons || [];
};

watchEffect(() => {
  const { id } = route.query;
  if (id) {
    if (!actionButtons.value.includes("90")) {
      actionButtons.value.unshift("90");
    }
  }
});


let form = ref({
  LicenseName: "",
  CompanyName: "",
  TaxNumber: "",
  LegalPersons: "",
  TaxType: "",
  ShareholderFullName: "",
  PageFiles: [],
});

const visible = ref<boolean>(false);
const rejectedVisible = ref<boolean>(false);
const applyOnOkVisible = ref<boolean>(false);
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
const reEdit = ref<boolean>(false); //是否点击重新发起标识
const edit = computed(() => actionButtons.value.includes("100"));

const tableData = [
  {
    depart: "财务管理中心",
    name: "宋宁",
    duty: "账套审批",
    email: "sunny.sn@risfond.com",
    phone: "19801196330",
  },
];
const list = ["提交账套申请", "审批通过后告知账套号"];

const handleReSubmit = () => {
  applyFormRef.value?.validateFields().then(async (res) => {
    const { Success, Message } = await startAccountSetApplication({
      Id: 0,
      LicenseName: form.value.LicenseName,
      TaxNumber: form.value.TaxNumber,
      TaxType: form.value.TaxType,
      ShareholderFullName: form.value.ShareholderFullName,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

const handleClick = async (buttonType: string | number) => {
  if (buttonType == "100") {
    //提交申请
    handleReSubmit();
  } else if (buttonType == "101") {
    //撤回申请
    visible.value = true;
  } else if (buttonType == "102") {
    preButton.value = actionButtons.value;
    actionButtons.value = ["-1", "-2"];
    reEdit.value = true;
  } else if (buttonType == "104") {
    //驳回
    rejectedVisible.value = true;
  } else if (buttonType == "103") {
    applyOnOkVisible.value = true;
  } else if (buttonType == "-1") {
    reEdit.value = false;
  } else if (buttonType == "-2") {
    handleReSubmit();
  }
};

const handleRejectback = () => {
  rejectedVisible.value = false;
  $emit("update-flow");
  getList();
  refresh.value = !refresh.value;
};
const handleApplyOnOk = () => {
  applyOnOkVisible.value = !applyOnOkVisible.value;
  refresh.value = !refresh.value;
  $emit("update-flow");
  getList();
};
const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};
const handleCallback = (update: boolean) => {
  if (visible.value) {
    visible.value = false;
  } else {
    visible.value = true;
  }
  if (update) {
    $emit("update-flow");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Reject = _resolveComponent("Reject")!
  const _component_ApplyOnOK = _resolveComponent("ApplyOnOK")!
  const _component_RecallBack = _resolveComponent("RecallBack")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeadTitle, { title: "账套申请流程" }),
        _createVNode(HelpText, {
          class: "border-bottom",
          list: list,
          width: 190,
          height: 70
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeadTitle, { title: "流程对接部门及名单" })
        ]),
        _createVNode(_component_a_table, {
          pagination: false,
          dataSource: tableData,
          columns: _unref(USERLIST)
        }, null, 8, ["columns"])
      ]),
      (
        (_unref(personInfo).IsCreate == 1 || (id.value && _unref(personInfo).IsCreate == 0)) &&
        currentData.value &&
        currentData.value.IsDataAccess == 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(HeadTitle, { title: "审批事项" }),
              _createElementVNode("div", _hoisted_6, [
                (WorkFlowId.value == 0 || reEdit.value)
                  ? (_openBlock(), _createBlock(_component_a_form, {
                      key: 0,
                      class: _normalizeClass(["apply-form-wrapper", 
              currentData.value && currentData.value.State > 1 && !reEdit.value
                ? 'border-bottom'
                : ''
            ]),
                      ref_key: "applyFormRef",
                      ref: applyFormRef,
                      model: _unref(form),
                      layout: "inline",
                      validateTrigger: "blur"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "营业执照名称",
                          class: "apply-form-item",
                          name: "LicenseName",
                          required: "",
                          colon: false,
                          rules: [{ required: true, message: '请输入营业执照名称' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(form).LicenseName,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).LicenseName) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "系统公司简称",
                          class: "apply-form-item",
                          name: "CompanyName",
                          required: "",
                          colon: false,
                          rules: []
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(form).CompanyName,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).CompanyName) = $event)),
                              placeholder: "请输入",
                              disabled: ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "纳税识别号",
                          class: "apply-form-item",
                          name: "TaxNumber",
                          required: "",
                          colon: false,
                          rules: [{ required: true, message: '请输入纳税识别号' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(form).TaxNumber,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).TaxNumber) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "法人",
                          class: "apply-form-item",
                          name: "LegalPersons",
                          required: "",
                          colon: false,
                          rules: []
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(form).LegalPersons,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).LegalPersons) = $event)),
                              placeholder: "请输入",
                              disabled: ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "纳税类型",
                          class: "apply-form-item tipsFormItem",
                          name: "TaxType",
                          colon: false,
                          rules: [{ required: true, message: '请选择纳税类型' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _unref(form).TaxType,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).TaxType) = $event)),
                              placeholder: "请选择"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _hoisted_8
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _hoisted_9
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "股东全称",
                          class: "apply-form-item",
                          name: "ShareholderFullName",
                          required: "",
                          colon: false,
                          rules: [{ required: true, message: '请输入股东全称' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(form).ShareholderFullName,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).ShareholderFullName) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          class: "imgItem",
                          name: ['PageFiles', 0, 'FileUrl'],
                          label: "营业执照正本",
                          colon: false,
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              value: 
                  _unref(form).PageFiles && _unref(form).PageFiles.length > 1
                    ? _unref(form).PageFiles[0].FileUrl
                    : ''
                ,
                              "disable-close": true,
                              disable: true,
                              "file-type": '541'
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          style: {"margin-left":"60px"},
                          class: "imgItem",
                          name: ['PageFiles', 1, 'FileUrl'],
                          label: "营业执照副本",
                          required: "",
                          colon: false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              value: 
                  _unref(form).PageFiles && _unref(form).PageFiles.length > 1
                    ? _unref(form).PageFiles[1].FileUrl
                    : ''
                ,
                              "disable-close": true,
                              disable: true,
                              "file-type": '542'
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["class", "model"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["margin-bottom", 
              currentData.value && currentData.value.State > 1 && !reEdit.value
                ? 'border-bottom'
                : ''
            ])
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("span", null, _toDisplayString(_unref(form).LicenseName), 1)
                        ]),
                        _createElementVNode("span", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("span", null, _toDisplayString(_unref(form).CompanyName), 1)
                        ]),
                        _createElementVNode("span", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("span", null, _toDisplayString(_unref(form).TaxNumber), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("span", null, _toDisplayString(_unref(form).LegalPersons), 1)
                        ]),
                        _createElementVNode("span", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("span", null, _toDisplayString(_unref(form).TaxTypeText), 1)
                        ]),
                        _createElementVNode("span", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("span", null, _toDisplayString(_unref(form).ShareholderFullName), 1)
                        ])
                      ]),
                      _createVNode(_component_a_form, {
                        model: _unref(form),
                        layout: "inline"
                      }, {
                        default: _withCtx(() => [
                          (_unref(form).PageFiles.length > 1 && _unref(form).PageFiles)
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 0,
                                class: "imgItem",
                                name: ['PageFiles', 0, 'FileUrl'],
                                label: "营业执照正本",
                                colon: false,
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(Image, {
                                    value: 
                    _unref(form).PageFiles && _unref(form).PageFiles.length > 1
                      ? _unref(form).PageFiles[0].FileUrl
                      : ''
                  ,
                                    "disable-close": true,
                                    disable: true,
                                    "file-type": '541'
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(form).PageFiles.length > 1 && _unref(form).PageFiles)
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 1,
                                style: {"margin-left":"60px"},
                                class: "imgItem",
                                name: ['PageFiles', 1, 'FileUrl'],
                                label: "营业执照副本",
                                required: "",
                                colon: false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(Image, {
                                    value: 
                    _unref(form).PageFiles && _unref(form).PageFiles.length > 1
                      ? _unref(form).PageFiles[1].FileUrl
                      : ''
                  ,
                                    "disable-close": true,
                                    disable: true,
                                    "file-type": '542'
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ], 2)),
                (currentData.value && currentData.value.State > 1 && !reEdit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(HeadTitle, {
                        title: '审批流程',
                        class: "flow-box-headtitle"
                      }),
                      _createVNode(Approval, {
                        id: WorkFlowId.value,
                        refresh: refresh.value
                      }, null, 8, ["id", "refresh"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(actionButtons).length > 0)
      ? (_openBlock(), _createBlock(ButtonGroup, {
          key: 0,
          "type-list": _unref(actionButtons),
          onClick: handleClick,
          "show-tips": 
      preData.value && preData.value.Title
        ? `提示：完成开设系统帐号、银行开户及税务报道审批后方可申请该模块`
        : ''
    
        }, null, 8, ["type-list", "show-tips"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Reject, {
      id: WorkFlowId.value,
      show: rejectedVisible.value,
      onClose: handleRejectback
    }, null, 8, ["id", "show"]),
    _createVNode(_component_ApplyOnOK, {
      id: WorkFlowId.value,
      show: applyOnOkVisible.value,
      applyType: 13,
      onClose: handleApplyOnOk
    }, null, 8, ["id", "show"]),
    _createVNode(_component_RecallBack, {
      id: BranchCompanyFlowId.value,
      show: visible.value,
      onClose: handleCallback
    }, null, 8, ["id", "show"])
  ], 64))
}
}

})